import { useState } from 'react'
import { useMutation } from 'react-apollo-hooks'
// import { useScript } from 'the-platform'
import useScript from './useScript'
import _get from 'lodash/get'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'

const useOmiseOffsite = (method, publicKey, onError) => {
  // const [paymentLoading, setPaymentLoading] = useState(false)
  // useScript({ src: 'https://cdn.omise.co/omise.js.gz' })
  const [loaded, error] = useScript('https://cdn.omise.co/omise.js.gz')
  error && console.error(error)
  const [paymentLoading, setPaymentLoading] = useState(false)
  const payRegistration = useMutation(payRegistrationMutation)
  const pay = async (sourceType, registration, src) => {
    setPaymentLoading(true)
    // eslint-disable-next-line no-undef
    Omise.setPublicKey(publicKey)
    try {
      const source = await new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        Omise.createSource(sourceType, {
          currency: 'thb',
          ...src,
          amount: Math.round(src.amount * 100)
        }, (statusCode, response) => {
          if (statusCode !== 200) {
            return reject(response.message)
          }
          return resolve(response)
        })
      })

      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method,
            data: {
              omise: {
                source: { id: source.id },
                returnUri: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
              }
            }
          }
        }
      })
      const authorizeUri = _get(
        data,
        'payRegistration.record.data.omise.charge.authorize_uri'
      )
      if (authorizeUri) window.location.href = authorizeUri
      // return window.location.href = `${process.env
      //   .REACT_APP_BASE_URI}/reg/${registration._id}`
    } catch (err) {
      onError(err)
    } finally {
      setPaymentLoading(false)
    }
  }
  return [loaded, paymentLoading, pay]
}

export default useOmiseOffsite



// WEBPACK FOOTER //
// ./src/App/hooks/useOmiseOffsite.js